import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { IN_PROGRESS } from "commons/src/helpers/RequestHelpers";

import { DocumentsList } from "./DocumentsList";
import { getSelectedAccountNum } from "../../helpers/NavigationHelpers";
import { requestObject } from "../../reducers/requestsActions";

function DocumentsContainerComponent({
    match,
    history,
    accounts,
    documents,
    totalDocuments,
    nextPage,
    requestStatus
}) {
    const accountNum = getSelectedAccountNum(match.params.accountNum, accounts || {});

    return (
        <DocumentsList
            account={accountNum}
            rangeId={match.params.rangeId}
            documentCategory={match.params.documentCategory}
            accounts={accounts}
            documents={documents}
            totalDocuments={totalDocuments}
            nextPage={nextPage}
            history={history}
            requestStatus={requestStatus}
        />
    );
}

DocumentsContainerComponent.defaultProps = {
    requestStatus: {
        status: IN_PROGRESS
    }
};

DocumentsContainerComponent.propTypes = {
    accounts: PropTypes.object,
    documents: PropTypes.array,
    history: PropTypes.object,
    match: PropTypes.shape({
        params: PropTypes.shape({
            accountNum: PropTypes.string,
            documentCategory: PropTypes.string,
            rangeId: PropTypes.string
        })
    }),
    requestStatus: requestObject,
    nextPage: PropTypes.string,
    totalDocuments: PropTypes.number
};

const mapStateToProps = state => ({
    accounts: state.accounts,
    documents: state.documents.documents,
    totalDocuments: state.documents.totalDocuments,
    nextPage: state.documents.nextPage,
    requestStatus: state.requests.correspondences
});

export const DocumentsContainer = connect(mapStateToProps)(DocumentsContainerComponent);
